import { retriableLazyImport } from '@gcx-si/vue-components/retriableLazyImport'

import type { RouteRecordRaw } from 'vue-router'

import { constants } from '@/globals'

export default {
  path: 'general-information',
  meta: {
    navigation: {
      labelKey: 'app.general.pages.information.title',
      targetName: constants.ROUTES_GENERAL_INFORMATION,
    },
  },
  children: [
    {
      path: '',
      component: retriableLazyImport(() => import('./pages/Information.vue')),
      name: constants.ROUTES_GENERAL_INFORMATION,
    },
  ],
} as RouteRecordRaw
